import { BusinessUnitEnum } from 'src/app/shared/enum/business-unit.enum';
import { Component, OnInit, ChangeDetectorRef, AfterViewInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import { Observable } from 'rxjs';
import { map, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import * as _ from 'lodash';
import { RequestAccessTypesEnum } from 'src/app/shared/enum/request-access-types.enum';
import { RedirctUrlService } from 'src/app/shared/services/redirct-url.service';
import { Location } from '@angular/common';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'
import { RegexEnum } from 'src/app/core/enum/regex.enum';
@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateCarrierComponent implements OnInit, AfterViewInit {

  public carrierOptions = [];
  public invalidCarrier = false;
  public selectedCarrier;
  public carrierUserID: string;
  public carrierName: string;
  private sub: any;
  public userType: string = 'user';
  public viewOnly: boolean = false;
  public loading: boolean = false;
  public carrierUpdate: {} = { organizationCode: '' };
  public privileges: {} = {
    HC_CARRIER_CREATE_USER: false, HC_CARRIER_DELETE_USER: false,
    HC_CARRIER_UPDATE_USER: false, HC_CARRIER_VIEW_USER: false
  };
  public userManagement: boolean = false;
  public originLimitations: boolean = false;
  public destinationLimitations: boolean = false;
  public isAdhoc: boolean = false;
  public currentUserRole: string = '';
  public phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
  public roleOptions: object[] = [];
  public carrierNamesList = [];
  public carrierInfo: string = '';
  public disableSubmitButton: boolean = true;
  public splitValue: any;
  public carrier: any;
  public raTypes = RequestAccessTypesEnum;
  public currentUser: any;
  public notifications: any[] = [];
  public businessUnitEnum = BusinessUnitEnum;
  public keepOriginalOrder = (a, b) => a.key;
  public selectedCarrierId: string;
  public userLocations: string[] = [];
  public invalidUserVisibility: boolean = false;

  public carrierAdminRole: {} = {
    value: 'HC_CARRIER_ADMIN',
    name: 'Admin - I',
    description: 'Admin - I role grants a user permission to add, update, remove, and reset passwords. Users who have admin role automatically have accounting and invoicing roles.\nNote: This Admin - Type One role is intended to be assigned for carriers who are not freight brokers.'
  };
  public carrierAccountingRole: {} = {
    value: 'HC_CARRIER_ACCOUNTING',
    name: 'Accounting',
    description: 'Carrier Accounting Role that allows only invoicing-related actions, such as submitting invoice numbers and uploading paperwork.'
  };

  public carrierDispatcherRole: {} = {
    value: 'HC_CARRIER_DISPATCHER',
    name: 'Dispatcher',
    description: 'Carrier Dispatcher Role with load board access that allows the user the ability to bid on loads, accept/reject tenders, assign drivers and track a load through the lifecycle.'
  };

  public carrierBrokerAdminRole: {} = {
    value: 'HC_CARRIER_BROKER_ADMIN',
    name: 'Admin - II',
    description: 'Admin - II role gives a user permission to add, update, remove, and reset passwords. Users who have admin role automatically have broker role.\nNote: This Admin - II role is intended to be assigned for carriers who are also freight brokers.'
  };

  public carrierBrokerUserRole: {} = {
    value: 'HC_CARRIER_BROKER_USER',
    name: 'Broker',
    description: 'Broker role provide access to my shipments through which user can accept/reject tenders, assign drivers and track a load through lifecyle, and invoicing related actions such as submitting invoice number and updating paperwork.\nNote: Broker role does not provide access to the load board.'
  };
  public regexEnum = RegexEnum;

  constructor(
    public currentUserService: CurrentUserService,
    public carrierService: CarrierService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location,
    private _redirectUrl: RedirctUrlService,
    private cdRef: ChangeDetectorRef,
    public _header: HeaderService,
    public appNotificationsService: AppNotificationService
  ) { }

  async ngOnInit() {
    this.currentUser = this.currentUserService.user.firstname;
    this.carrierService.nameIsInvalid = false;
    if (!this.currentUserService.user) {
      this.router.navigate(['../../users'], { relativeTo: this.route });
      return false;
    }
    if (this.currentUserService.isInternal && !this.carrierService.all.length) {
      this.loading = true;
    }
    if (this.currentUserService.user.role.code === 'HC_CARRIER_ADMIN' || this.currentUserService.user.role.code === 'HC_CARRIER_BROKER_ADMIN'){
      this.disableSubmitButton = false;
    }
    this.assignRoleValues();
    this.sub = this.route.queryParams.subscribe(params => {
      if (params.request) {
        this.carrierService.resetCarrierUser();
        this.carrierService.newCarrierUser.organizationName = params.carrierName;
        this.carrierService.newCarrierUser.requestId = _.get(params, 'request', null);
        this.carrierService.newCarrierUser.name = params.name;
        this.carrierService.newCarrierUser.email = params.email;
        this.carrierService.newCarrierUser.phone = params.phone;
        this.carrierService.newCarrierUser.user_from_request = true;
        this.carrierService.newCarrierUser.requestType = params.requestType;
        if (params.mobile_phone !== 'null') {
          this.carrierService.newCarrierUser.mobile_phone = params.mobilePhone;
        }
      } else if (params.edit) {
        this.carrierService.newCarrierUser.organizationName = params.carrierName;
        this.carrierService.newCarrierUser.name = params.name;
        this.carrierService.newCarrierUser.email = params.email;
        this.carrierService.newCarrierUser.phone = params.phone;
        this.selectedCarrierId = params.carrierUserID;
        if (params.mobile === 'null' || params.mobile === 'undefined') {
          this.carrierService.newCarrierUser.mobile_phone = null;
        } else {
          this.carrierService.newCarrierUser.mobile_phone = params.mobile;
        }
        this.carrierService.newCarrierUser.roleCode = params.userType;

        if (params.entitlements.constructor === String) {

          this.matchPrivileges(params.entitlements);
        } else {
          params.entitlements.forEach((p) => {
            this.matchPrivileges(p);
          });
        }
      } else {
        this.carrierService.resetCarrierUser();
        if (params.requestType) {
          this.carrierService.newCarrierUser.requestType = params.requestType;
        }
        this.resetPrivileges();
      }
      if (this.checkIfHubAdminAndForCarrier()) {
        this.setUnitAndMode(params.mode, params.unit);
      }
      if (this.currentUserService.user.role.type.toLowerCase() === 'carrier') {
        this.carrierService.newCarrierUser.organization_id = this.currentUserService.user.organizationCode;
        this.carrierService.newCarrierUser.organizationName = this.currentUserService.user.organizationName;
        this.selectedCarrierId = this.selectedCarrierId || this.currentUserService.user.organizationCode;
      }
      if (params.carrierID) {
        this.carrierService.newCarrierUser.organization_id = params.carrierID;
      }
      if (params['vendorLocations']) {
        this.userLocations = params['vendorLocations'];
      }
    });

    if (await this.appNotificationsService.getNotificationEnabledStatus()) this.appNotificationsService.loadNotifications('general', 0);
  }

  ngOnDestroy() {

  }

  public checkIfHubAdminAndForCarrier() {
    return this.currentUserRole === 'hubAdmin' && this.carrierService.newCarrierUser.requestType !== this.raTypes.FACTORING_COMPANY;
  }

  public setUnitAndMode(mode = 'TL', unit = ['HWY']) {
    this.carrierService.carrierUnit.transportMode = mode;
    if (typeof unit === 'object') {
      this.carrierService.carrierUnit.businessUnit = unit;
    } else {
      this.carrierService.carrierUnit.businessUnit = [unit];
    }
  }

  public assignRoleValues() {
    if (this.currentUserService.user.role.code === 'HC_CARRIER_ADMIN') {
      this.currentUserRole = 'carrierAdmin';
      this.roleOptions = [this.carrierAdminRole, this.carrierAccountingRole, this.carrierDispatcherRole, this.carrierBrokerAdminRole, this.carrierBrokerUserRole];
    } else if (this.currentUserService.user.role.code === 'HC_CARRIER_BROKER_ADMIN') {
      this.currentUserRole = 'carrierBrokerAdmin';
      this.roleOptions = [this.carrierBrokerAdminRole, this.carrierBrokerUserRole];
    } else if (this.currentUserService.isInternal) {
      this.currentUserRole = 'hubAdmin';
      this.roleOptions = [this.carrierAdminRole, this.carrierAccountingRole, this.carrierDispatcherRole, this.carrierBrokerAdminRole, this.carrierBrokerUserRole];
    }
  }
  ngAfterViewInit() {
    this._carrierSearchSetUp();
  }

  ngAfterViewChecked() {
    this.cdRef.detectChanges();
  }

  public matchPrivileges(privilege) {
    this.privileges[privilege] = true;
    if (privilege === 'HC_CR_CREATE_USER' || privilege === 'HC_CR_DELETE_USER' ||
      privilege === 'HC_CR_UPDATE_USER' || privilege === 'HC_CR_VIEW_USER') {
      this.userManagement = true;
    }
  }

  public setupPrivileges() {
    this.resetPrivileges();
    var allowed = []; //misc privlegies that are allowed by each role

    // CARRIER ADMIN
    if (this.carrierService.newCarrierUser.roleCode === 'HC_CARRIER_ADMIN') {
      allowed = [];
      this.userManagement = true;
    }

    // CARRIER ACCOUNTING
    else if (this.carrierService.newCarrierUser.roleCode === 'HC_CARRIER_ACCOUNTING') {
      allowed = [];
      this.userManagement = false;
    }

    else if (this.carrierService.newCarrierUser.roleCode === 'HC_CARRIER_DISPATCHER') {
      allowed = [];
      this.userManagement = false;
    }

    this.allowPrivileges(allowed);
  }

  resetPrivileges() { // sets all the user privileges to false/defaults
    for (var key in this.privileges) {
      this.privileges[key] = false;
    }
  }

  allowPrivileges(allowed) { // adds the set privileges for roles
    allowed.forEach(element => {
      this.privileges[element] = true;
    });
    this.toggleCarrierManagementChoices();
  }

  public toggleCarrierManagementChoices() {
    if (this.userManagement == true) {
      this.privileges['HC_CR_CREATE_USER'] = true;
      this.privileges['HC_CR_DELETE_USER'] = true;
      this.privileges['HC_CR_UPDATE_USER'] = true;
      this.privileges['HC_CR_VIEW_USER'] = true;
    } else {
      this.privileges['HC_CR_CREATE_USER'] = false;
      this.privileges['HC_CR_DELETE_USER'] = false;
      this.privileges['HC_CR_UPDATE_USER'] = false;
      this.privileges['HC_CR_VIEW_USER'] = false;
    }
  }
  /**
  * Setup Carrier search
  * Observes the element with id "addCarrierSearch"
  * Waits 500 milliseconds before it sends filter request to back end
  */
  private _carrierSearchSetUp() {
    Observable.fromEvent(document.getElementById('addCarrierSearch'), 'input').pipe(
      map((e: KeyboardEvent) => {
        const element = e.target as HTMLInputElement;
        const value = element.value;
        return value;
      }),
      debounceTime(500),
      distinctUntilChanged()
    ).subscribe((searchText: any) => {
      if (!searchText || !searchText.trim().length || searchText.trim().length < 3) {
        this.carrierOptions = [];
        this.carrierNamesList = [];
        this.disableSubmitButton = true;
        this.invalidCarrier = false;
        this.cdRef.detectChanges();
      } else {
        /**
         * route to accounting service and fetch the factoring companies
         * distinct companies.
         */
        if (this.carrierService.newCarrierUser.requestType === this.raTypes.FACTORING_COMPANY) {
          this.getErpFactoringData(searchText);
        } else {
          this.carrierService.getCarriersTextSearch(searchText.trim()).subscribe((data: any[]) => {
            this.selectedCarrierId = "";
            this.carrierNamesList = [];
            this.carrierOptions = data;
            data.forEach(carrier => {
              let sysconNumber = ' (Syscon# N/A) ';
              this.carrierInfo = carrier.carrierName;
              if (carrier.xrefIds.length < 1) {
              } else {
                carrier.xrefIds.forEach(xref => {
                  if (xref.systemName === 'TPS') {
                    sysconNumber = ' (Syscon#' + xref.id + ') ';
                  }
                });
              }
              const scacCode = _.get(_.first(carrier.scacs), 'code') || ' N/A';
              this.carrierInfo += sysconNumber;
              this.carrierInfo += ' (SCAC#' + scacCode + ') ';
              this.carrierInfo += carrier.mcNumber ? ' (MC#' + carrier.mcNumber + ') ' : ' (MC# N/A) ';
              this.carrierInfo += carrier.carrierId ? ' (C#' + carrier.carrierId + ') ' : ' (C# N/A) ';
              carrier.locations.forEach(location => {
                if (location.primary) {
                  if (location.address) {
                    this.carrierInfo += ', ' + (location.address.city || 'N/A') + ', '+ (location.address.state || 'N/A') + ', '+ (location.address.zipCode || 'N/A');
                  }
                }
              });
              this.carrierNamesList.push(this.carrierInfo);

            });
          });
          this.cdRef.detectChanges();
        }
      }
    });
  }

  onSubmit() {
    const selectedPrivileges = [];
    const myObj = this.privileges;
    Object.keys(myObj).forEach(function (privilege) {
      if (myObj[privilege] == true) {
        selectedPrivileges.push(privilege);
      }
    });
    this.carrierService.newCarrierUser.entitlements = selectedPrivileges;
    if (this.checkIfHubAdminAndForCarrier()) {
      this.carrierService.carrierUnit.transportMode = !this.carrierService.carrierUnit.businessUnit.includes('LGS') ? 'TL' : this.carrierService.carrierUnit.transportMode;
    }
    if (this.userLocations && this.userLocations.length && this.showUserVisibility()) {
      this.carrierService.newCarrierUser.vendorLocations = this.userLocations;
    } else {
      _.unset(this.carrierService.newCarrierUser, "vendorLocations");
    }
    this.router.navigate(['../confirm'], { relativeTo: this.route, queryParams: { ID: this.carrierService.newCarrierUser.organization_id, requestType: this.carrierService.newCarrierUser.requestType} });
  }

  selectCarrier(carrier: string) {
    if (this.carrierService.newCarrierUser.requestType === this.raTypes.FACTORING_COMPANY) {
      this.disableSubmitButton = false;
      this.splitValue = carrier.split(' (');
      this.selectedCarrier = _.find(
        this.carrierOptions,
        data => data.name === this.splitValue[0].trim()
      );
      this.carrierService.newCarrierUser.organization_id = this.selectedCarrier.id; // fac comp id
      this.carrierService.newCarrierUser.organizationName = this.selectedCarrier.name; // fac comp name
      (<HTMLInputElement>document.getElementById('addCarrierSearch')).value = carrier;
      this.carrierNamesList = [];
      this.carrierOptions = [];
    } else {
      this.disableSubmitButton = false;
      this.splitValue = carrier.split(' (Syscon#');
      const cNumber = carrier.match(/\(C#(\w+)\)/)[1].trim();
      this.selectedCarrier = _.find(
        this.carrierOptions,
        data => data.carrierName === this.splitValue[0].trim() && data.carrierId === cNumber
      );
      if (!this.carrierService.newCarrierUser.requestId && this.carrierService.newCarrierUser.organizationName !== this.selectedCarrier.carrierName) {
        this.carrierService.updateCarrierUnit(this.selectedCarrier.carrierId);
      }
      this.carrierService.newCarrierUser.organization_id = this.selectedCarrier.carrierId;
      this.carrierService.newCarrierUser.organizationName = this.selectedCarrier.carrierName;
      this.selectedCarrierId = this.selectedCarrier.carrierId;
      (<HTMLInputElement>document.getElementById('addCarrierSearch')).value = carrier;
      this.carrierNamesList = [];
      this.carrierOptions = [];
    }
  }

  blurCarrierInput() {
    if (!this.carrierOptions.length) {
      this.invalidCarrier = true;
    } else {
      this.invalidCarrier = false;
    }
  }

  clearInputValue() {
    (<HTMLInputElement>document.getElementById('addCarrierSearch')).value = '';
    this.carrierOptions = [];
  }

  getErpFactoringData(searchValue) {
    this.carrierService.getFactoringCompanies(searchValue.trim()).subscribe((data: any[]) => {
      this.carrierNamesList = [];
      this.carrierOptions = data;
      data.forEach(factoringCompany => {
        this.carrierInfo = factoringCompany.name;
        this.carrierInfo += factoringCompany.id ? ' (' + factoringCompany.id + ') ' : ' (N/A) ';
        this.carrierNamesList.push(this.carrierInfo);
        this.cdRef.detectChanges();
      });
    });
  }

  public onRedirectHandler($event) {
    this._redirectUrl.onLogoutHandler($event);
  }

  public onBackEventHandler() {
    this.location.back();
  }

  showUserVisibility() {
    if (this.checkIfHubAdminAndForCarrier()) {
      return this.carrierService.carrierUnit.businessUnit && this.carrierService.carrierUnit.businessUnit.includes('IML') && this.selectedCarrierId;
    } else if (this.carrierService.newCarrierUser.requestType !== this.raTypes.FACTORING_COMPANY) {
      return this.selectedCarrierId && this.currentUserService.user.extended.locations;
    }
  }

  onLocation($event) {
    this.invalidUserVisibility = _.isEmpty($event);
    this.userLocations = $event;
  }

  isInvalidUserVisibility() {
    if (!this.carrierService.carrierUnit.businessUnit || this.carrierService.carrierUnit.businessUnit.includes('IML')) {
      return this.invalidUserVisibility;
    }
    return false;
  }
}
